/**
 * Breakpoints System
 * Defines responsive breakpoints for mobile, compact, and web
 */

export enum Viewport {
  Mobile = 'mobile',
  Compact = 'compact',
  Web = 'web',
}

const breakpoints = {
  mobile: 900,   // px - screens below this are mobile
  compact: 900,  // px - screens at or above this are compact
  web: 1465,     // px - screens at or above this are web
} as const;

/**
 * Media query strings for use in CSS-in-JS or styled components
 */
export const mediaQueries = {
  mobile: `(max-width: ${breakpoints.mobile - 1}px)`,
  compact: `(min-width: ${breakpoints.compact}px) and (max-width: ${breakpoints.web - 1}px)`,
  web: `(min-width: ${breakpoints.web}px)`,
  mobileOnly: `(max-width: ${breakpoints.mobile - 1}px)`,
  compactOnly: `(min-width: ${breakpoints.compact}px) and (max-width: ${breakpoints.web - 1}px)`,
  webOnly: `(min-width: ${breakpoints.web}px)`,
} as const;

/**
 * Get viewport type from width
 */
function getViewportFromWidth(width: number): Viewport {
  if (width < breakpoints.mobile) return Viewport.Mobile;
  if (width < breakpoints.web) return Viewport.Compact;
  return Viewport.Web;
}
